var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"champ",class:_vm.getClasses,attrs:{"contenteditable":_vm.edition,"placeholder":_vm.placeholder},domProps:{"innerHTML":_vm._s(_vm.innerHTML)},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }